const COMMON_CONFIGS = {
  recaptcha_key: process.env.REACT_APP_RECAPTCHA_SECRET_KEY,
  website_url: process.env.REACT_APP_PATIENT_URL,
  base_url: process.env.REACT_APP_GATEWAY_URL
};

const config = {
  production: {
    ...COMMON_CONFIGS,
    env: process.env.NODE_ENV,
    base_url: process.env.REACT_APP_GATEWAY_URL
  },
  development: {
    ...COMMON_CONFIGS,
    env: process.env.NODE_ENV
  },
  test: {
    ...COMMON_CONFIGS,
    env: process.env.NODE_ENV,
    base_url: process.env.REACT_APP_GATEWAY_URL
  }
};

export default config[process.env.NODE_ENV];
